import { useErpInfo, AvailabilityWrapper } from "@bundles/erp"
import { Box, ErpPriceWithAdditionalInfo, Loader, Prices, Stack } from "@tm/components"
import { useHidePriceTypes } from "@tm/context-distribution"
import { Article } from "@tm/models"
import { RimArticle } from "@bundles/wheels/data/model"
import { getShowIndustrialAvailability } from "@bundles/wheels/data/helpers/getShowIndustrialAvailability"

export function ErpWrapper(article: RimArticle | Article) {
    const showIndustrialAvailability = getShowIndustrialAvailability((article as RimArticle).stock)
    const { loading, erpInfo } = useErpInfo(article as Article, "list", undefined, undefined, article.supplierArticleNo, showIndustrialAvailability)
    const { isPriceTypeHidden } = useHidePriceTypes()

    const prices =
        erpInfo?.prices
            ?.filter((x) => x.type)
            .map<ErpPriceWithAdditionalInfo>((x) => ({
                ...x,
                onlyShowInfo: isPriceTypeHidden(x.type),
            })) ?? []

    return (
        <Stack direction="row" alignItems="center" gap={2} justifyContent="space-between" minWidth="16em">
            {loading ? (
                <Loader size="small" />
            ) : (
                <>
                    <AvailabilityWrapper
                        hasReplacedArticles={!!(erpInfo?.articles && erpInfo.articles.length)}
                        availability={erpInfo?.availability}
                        tour={erpInfo?.tour}
                        warehouses={erpInfo?.warehouses}
                        requestedQuantity={erpInfo?.quantity?.requestedValue}
                        specialProcurementInformation={erpInfo?.specialProcurementErpInformation}
                        useSpecialProcurement={erpInfo?.useSpecialProcurement}
                    />
                    <Box minWidth="6em">
                        <Prices prices={prices} isCompact />
                    </Box>
                </>
            )}
        </Stack>
    )
}
